import Seo from "../../Components/SEO/Seo";


import Hero from "../../Components/Home/Hero/Hero";
import TrustStats from "../../Components/Home/TrustStats/TrustStats";
import About from "../../Components/Home/About/About";
import Services from "../../Components/Home/Services/Services";
import DataSolutions from "../../Components/Home/DataSolutions/DataSolutions";
import Process from "../../Components/Home/Process/Process";
import LeadGeneration from "../../Components/Home/LeadGeneration/LeadGeneration";
import Recruitment from "../../Components/Home/Recruitment/Recruitment";

import CEO from "../../Components/Home/CEO/CEO";
import WhyChooseUs from "../../Components/Home/WhyChooseUs/WhyChooseUs";
import Industries from "../../Components/Home/Industries/Industries";
import Testimonials from "../../Components/Home/Testimonials/Testimonials";
import CaseStudies from "../../Components/Home/CaseStudies/CaseStudies";
import KnowledgeHub from "../../Components/Home/KnowledgeHub/KnowledgeHub";
import Technology from "../../Components/Home/Technology/Technology";
// import FAQ from "../../Components/Home/FAQ/FAQ";
import Partners from "../../Components/Home/Partners/Partners";
import CTA from "../../Components/Home/CTA/CTA";

function Home() {
  return (
    <>
      <Seo
        title="Conectify Tech | Data, Digital Marketing & Growth Solutions"
        description="Conectify Tech helps businesses turn data into leads, customers and measurable growth through digital marketing, data intelligence and technology-driven solutions."
      />

      <a className="skip-link" href="#main">
        Skip to content
      </a>

      <main id="main">
        <Hero />
        <TrustStats />
        <About />
        <Services />
        <DataSolutions />
        <Process />
        <LeadGeneration />
        <Recruitment />

        <CEO />
        <WhyChooseUs />
        <Industries />
        <Testimonials />
        <CaseStudies />
        <KnowledgeHub />
        <Technology />
        {/* <FAQ /> */}
        <Partners />
        <CTA />
      </main>

      
    </>
  );
}

export default Home;